import {engineContext} from './context.js';

(function(global){'use strict';
const VERSION='0.1.0-alpha';
const SCHEMA_VERSION='1';

function clone(x){ return x==null?x:JSON.parse(JSON.stringify(x)); }

function pack(input){
  input=input||{};
  const now=input.savedAt||new Date().toISOString();
  return Object.freeze({
    schemaVersion:SCHEMA_VERSION,
    engineVersion:VERSION,
    recordType:'ZOOINVEST_RESEARCH_STATE',
    symbol:input.symbol||null,
    scope:input.scope||'RESEARCH',
    savedAt:now,
    evidenceFingerprint:input.evidenceFingerprint||null,
    thesisFingerprint:input.thesisFingerprint||null,
    snapshot:clone(input.snapshot||null),
    readiness:clone(input.readiness||null),
    integrity:clone(input.integrity||null),
    brief:clone(input.brief||null),
    completionMemory:clone(input.completionMemory||[]),
    openGaps:clone(input.openGaps||[]),
    invalidations:clone(input.invalidations||[]),
    metadata:clone(input.metadata||{})
  });
}

function validateRecord(r){
  const issues=[];
  if(!r||typeof r!=='object') issues.push('RECORD_NOT_OBJECT');
  else {
    if(r.recordType!=='ZOOINVEST_RESEARCH_STATE') issues.push('INVALID_RECORD_TYPE');
    if(!r.schemaVersion) issues.push('MISSING_SCHEMA_VERSION');
    if(!r.symbol) issues.push('MISSING_SYMBOL');
    if(!r.savedAt) issues.push('MISSING_SAVED_AT');
    if(r.completionMemory && !Array.isArray(r.completionMemory)) issues.push('INVALID_COMPLETION_MEMORY');
    if(r.openGaps && !Array.isArray(r.openGaps)) issues.push('INVALID_OPEN_GAPS');
    if(r.invalidations && !Array.isArray(r.invalidations)) issues.push('INVALID_INVALIDATIONS');
  }
  return Object.freeze({valid:issues.length===0,issues:Object.freeze(issues)});
}

function migrate(r){
  const x=clone(r||{});
  if(!x.schemaVersion){
    x.schemaVersion='1';
    x.recordType=x.recordType||'ZOOINVEST_RESEARCH_STATE';
    x.completionMemory=Array.isArray(x.completionMemory)?x.completionMemory:[];
    x.openGaps=Array.isArray(x.openGaps)?x.openGaps:[];
    x.invalidations=Array.isArray(x.invalidations)?x.invalidations:[];
    x.metadata=x.metadata||{};
  }
  if(x.schemaVersion!==SCHEMA_VERSION){
    return Object.freeze({migrated:false,record:null,reason:'UNSUPPORTED_SCHEMA_VERSION'});
  }
  return Object.freeze({migrated:true,record:Object.freeze(x),reason:'CURRENT_SCHEMA'});
}

function diff(a,b){
  a=a||{}; b=b||{};
  const changed=[];
  const keys=['evidenceFingerprint','thesisFingerprint','scope'];
  for(const k of keys) if((a[k]??null)!==(b[k]??null)) changed.push(k);

  const aReady=JSON.stringify(a.readiness??null), bReady=JSON.stringify(b.readiness??null);
  if(aReady!==bReady) changed.push('readiness');

  const aInt=JSON.stringify(a.integrity??null), bInt=JSON.stringify(b.integrity??null);
  if(aInt!==bInt) changed.push('integrity');

  return Object.freeze({
    changed:Object.freeze(changed),
    evidenceChanged:changed.includes('evidenceFingerprint'),
    thesisChanged:changed.includes('thesisFingerprint'),
    readinessChanged:changed.includes('readiness'),
    integrityChanged:changed.includes('integrity')
  });
}

function storageKey(symbol,scope){
  return `zooinvest:research-state:v${SCHEMA_VERSION}:${String(scope||'RESEARCH').toUpperCase()}:${String(symbol||'UNKNOWN').toUpperCase()}`;
}

function selfTest(){
  const t=[],ok=(n,p)=>t.push({name:n,pass:!!p});
  const p=pack({symbol:'AAA',scope:'OWNED',savedAt:'2026-08-30T12:00:00Z',evidenceFingerprint:'e1',thesisFingerprint:'t1'});

  ok('pack sets schema version',p.schemaVersion==='1');
  ok('pack sets record type',p.recordType==='ZOOINVEST_RESEARCH_STATE');
  ok('pack preserves symbol',p.symbol==='AAA');
  ok('pack preserves scope',p.scope==='OWNED');
  ok('pack initializes completion memory',Array.isArray(p.completionMemory));
  ok('packed record validates',validateRecord(p).valid===true);

  ok('missing symbol rejected',validateRecord({...p,symbol:null}).valid===false);
  ok('wrong record type rejected',validateRecord({...p,recordType:'OTHER'}).valid===false);
  ok('bad open gaps type rejected',validateRecord({...p,openGaps:{}}).valid===false);

  const old={symbol:'AAA',savedAt:'x',recordType:'ZOOINVEST_RESEARCH_STATE'};
  const mig=migrate(old);
  ok('legacy record migrates to schema 1',mig.migrated===true&&mig.record.schemaVersion==='1');

  const bad=migrate({...p,schemaVersion:'99'});
  ok('unknown future schema blocked',bad.migrated===false&&bad.record===null);

  const d0=diff(p,p);
  ok('identical records have no tracked diff',d0.changed.length===0);

  const p2={...p,evidenceFingerprint:'e2'};
  const d1=diff(p,p2);
  ok('evidence fingerprint change detected',d1.evidenceChanged===true);
  ok('unchanged thesis remains unchanged',d1.thesisChanged===false);

  const p3={...p,readiness:{state:'REVIEW'}};
  ok('readiness change detected',diff(p,p3).readinessChanged===true);

  const key=storageKey('aaa','owned');
  ok('storage key is deterministic',key==='zooinvest:research-state:v1:OWNED:AAA');

  ok('pack does not emit trade signal',!('tradeSignal' in p));
  ok('pack does not emit capital permission',!('capitalPermission' in p));

  return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}

const API={VERSION,SCHEMA_VERSION,pack,validateRecord,migrate,diff,storageKey,selfTest};
try{API.selfTestResult=selfTest()}catch(e){API.bootstrapError=String(e&&e.stack||e)}
global.ZooInvestResearchStatePersistenceAdapter=Object.freeze(API);
})(engineContext);